/* @flow weak */
const CarouselPropTypes = {
  showBackControlsIndices: (props, propName) => {
    const indices = props[propName];
    if (indices) {
      if (indices.length !== 2 && Array.isArray(props[propName])) {
        return new Error('ShowBackControlsIndices must be array of length 2');
      }

      if (!Number.isInteger(indices[0])) {
        return new Error('ShowBackControlsIndices first index must be an integer');
      }

      if (!Number.isInteger(indices[1])) {
        return new Error('ShowBackControlsIndices second index must be an integer');
      }

      if (indices[0] < 0 || indices[1] < 0) {
        return new Error('ShowBackControlsIndices must be positive');
      }

      if (indices[0] > indices[1]) {
        return new Error('ShowBackControlsIndices first index must be lower than second index');
      }

      if (indices[1] > props.children.length - 1) {
        return new Error(
          'ShowBackControlsIndices second index must be less than or equal to number of children'
        );
      }
    }
  },
};

export default CarouselPropTypes;



// WEBPACK FOOTER //
// ./src/components/lib/CarouselPropTypes.js